export default __webpack_public_path__ + "static/media/cp_geo_tn.8ab7256a.svg";